import { memo, useCallback } from "react";
import TableCell from "@mui/material/TableCell";
import SelectCell from "./SelectCell";
import InputCell from "./InputCell";
import { QuestionChangeParams } from "../../types";
import {
  AssessmentQuestionTypes,
  QuestionDifficultyLevelEnum,
} from "../../../../utils/enums";
import { TEXT_ALIGN } from "@asez/shared";
import { STATIC_STRINGS } from "@asez/shared";
import { middleCellSx, questionTypeSx, rightCellSx } from "./tableStyles";

interface QuestionRowProps {
  topicIndex: number;
  questionIndex: number;
  question: any;
  handleChange: ({
    topicIndex,
    questionIndex,
    key,
    newValue,
  }: QuestionChangeParams) => void;
  handleDeleteType: any;
}

const QuestionRow = memo(
  ({
    topicIndex,
    questionIndex,
    question,
    handleChange,
    handleDeleteType,
  }: QuestionRowProps) => {
    const handleFieldChange = useCallback(
      (key) => (e) =>
        handleChange({
          topicIndex,
          questionIndex,
          key,
          newValue: e.target.value,
        }),
      [topicIndex, questionIndex, handleChange]
    );

    return (
      <>
        <SelectCell
          value={question.questionType}
          onChangeHandler={handleFieldChange("questionType")}
          options={Object.values(AssessmentQuestionTypes).map((type) => ({
            label: type,
            value: type,
          }))}
          classes="max-w-[180px] w-full"
          sx={{
            ...questionTypeSx,
            borderLeft: 1,
          }}
        />
        <SelectCell
          value={question.difficultyLevel}
          onChangeHandler={handleFieldChange("difficultyLevel")}
          options={Object.values(QuestionDifficultyLevelEnum).map((level) => ({
            label: level,
            value: level,
          }))}
          classes="max-w-[115px] w-full"
          sx={middleCellSx}
        />
        <InputCell
          type="text"
          value={question.numberOfQuestions}
          onChangeHandler={handleFieldChange("numberOfQuestions")}
          className="w-[100px]"
          textAlign={TEXT_ALIGN.center}
        />
        <InputCell
          type="text"
          value={question.additionalRequirements ?? ""}
          onChangeHandler={handleFieldChange("additionalRequirements")}
          className="max-w-[180px]"
        />
        <TableCell
          align="center"
          sx={{
            ...rightCellSx,
            borderRight: 1,
            borderColor: "var(--color-table-header)",
          }}
        >
          <div className="flex justify-center w-full">
            <button
              className="btn btn-outline p-1 xl:p-2 shadow-md w-20"
              onClick={() => handleDeleteType(topicIndex, questionIndex)}
            >
              {STATIC_STRINGS.DELETE}
            </button>
          </div>
        </TableCell>
      </>
    );
  }
);

export default QuestionRow;
